// CDN finalize hook: refresh/persist the bundle, then POST the token to the CDN
// cookie endpoint. One definition for both the redirect and programmatic journeys.

import type { OnFinalizeLogin } from '@lseg-ciam/auth/login';
import {
  createRefreshableToken$,
  createStatelessToken$,
  persistHeimdallBundleIfNeeded,
} from '@lseg-ciam/auth/token';
import { flog } from '@lseg-ciam/auth/utils';
import { filter, map, switchMap } from 'rxjs';
import { postCdnToken$ } from './cdn.js';

export const cdnFinalizeLoginHook: OnFinalizeLogin = ({ bundle, context }) => {
  const { persistTokens } = context;

  return (
    persistTokens
      ? createRefreshableToken$(bundle).pipe(
          persistHeimdallBundleIfNeeded(),
          flog('Refreshable token acquired + persisted'),
          map(
            (heimdallBundle) => heimdallBundle?.tokenSet.access_token['api.ws']
          )
        )
      : createStatelessToken$(bundle).pipe(
          flog('Stateless token acquired'),
          map((tokenSet) => tokenSet.access_token)
        )
  ).pipe(
    filter((token): token is string => !!token),
    switchMap((token) => postCdnToken$(token).pipe(flog('CDN relay complete')))
  );
};
